import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

import { useStatusContext } from "../../../../context/StatusContextProvider/StatusContextProvider";
import { botUrl, botToken, chatId, chatIdAdmin } from "../../../../user/home/BaseData";

import classes from "./Form.module.css";

export const Form = () => {
  const { t } = useTranslation();
  const [inputText, setInputText] = useState({
    name: "",
    surename: "",
    phone: "",
    email: "",
    userMessage: "",
  });
  const { onSuccessStatus } = useStatusContext();

  // input
  const handlInputChanger = (e) => {
    const { name, value } = e.target;

    setInputText({ ...inputText, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const url = `${botUrl}${botToken}/sendMessage`;

      const message = `
        Ism: ${inputText?.name}
        Familiya: ${inputText?.surename}
        Telefon: ${inputText?.phone}
        Elektron pochta: ${inputText?.email}
        Savol: ${inputText?.userMessage}
      `;

      await axios.post(url, {
        chat_id: chatId,
        text: message,
      });
      await axios.post(url, {
        chat_id: chatIdAdmin,
        text: message,
      });


      onSuccessStatus({
        message: "Murojaatingiz muvaffaqiyatli yuborildi!!!",
      });

      // Clear the input fields after successful data submission
      setInputText({
        name: "",
        surename: "",
        phone: "",
        email: "",
        userMessage: "",
      });
    } catch (error) {
      console.error("Failed to send message:", error);
    }
  };

  return (
    <div className={classes["message_form"]}>
      <div data-aos="fade-right" className={classes["left_side"]}>
        <h3 className={classes["form_title"]}>{t("Xabar yuborish")}</h3>
        <form onSubmit={handleSubmit}>
          <input
            placeholder={t("nameOfPlaceholder")}
            className={classes["form_input"]}
            type="text"
            name="name"
            onChange={(e) => handlInputChanger(e)}
            required
          />
          <input
            placeholder={t("surnameOfPlaceholder")}
            className={classes["form_input"]}
            type="text"
            name="surename"
            onChange={(e) => handlInputChanger(e)}
            required
          />
          <input
            placeholder={t("numberOfPlaceholder")}
            className={classes["form_input"]}
            type="text"
            name="phone"
            onChange={(e) => handlInputChanger(e)}
            required
          />
          <input
            placeholder={t("emailOfPlaceholder")}
            className={classes["form_input"]}
            type="text"
            name="email"
            onChange={(e) => handlInputChanger(e)}
            required
          />
          <textarea
            placeholder={t("messageOfPlaceholder")}
            className={classes["form_input"]}
            name="userMessage"
            cols="30"
            rows="10"
            userMessage="userMessage"
            onChange={(e) => handlInputChanger(e)}
            required
          ></textarea>
          <button type="submit" className={classes["form_btn"]}>
            {t("Xabarni yuborish")}
          </button>
        </form>
      </div>
      <div data-aos="fade-left" className={classes["right_side"]}>
        <h3 className={classes["advice_title"]}>{t("adviceOfContact")}</h3>
        <p className={classes["advice_descr"]}>{t("adviceDescr")}</p>

        <a href="tel:+998555067007" style={{ textDecoration: 'none' }}>
          <div
            style={{
              border: "1px solid #fff",
              padding: "20px",
              borderRadius: "7px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              fontSize: "18px",
              fontWeight: "600",
              color: "#fff"
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
            </svg>
            <span>+998 55 506 70 07</span>
          </div>
        </a>
      </div>
    </div>
  );
};
